import { isEmpty, sumBy } from 'lodash';

const targetingCriterionValidator = (
  { values, hasQuotas } = {},
  { completes } = {},
) => {
  const errors = {};

  if (isEmpty(values)) {
    errors.requiredValues = true;
  }

  if (hasQuotas) {
    const criterionQuotaSum = sumBy(values, 'quotaCompletes');
    const quotaSumError = completes && criterionQuotaSum < completes;
    if (quotaSumError) {
      errors.quotaSumError = true;
    }
  }

  return errors;
};

export default targetingCriterionValidator;
